/* eslint-disable camelcase */
import { intfc_prefix_common } from '@/core/api.config'
import request from '@/utils/request'

export function savefile (channels) {
  console.log(channels, 'channels')
  return request({
    // eslint-disable-next-line camelcase
    url: `${intfc_prefix_common}/api/collection/manuscript/add`,
    method: 'POST',
    data: channels.obj
  })
}

export function getActivityInfo ({ activityId }) {
  return request({
    url: `${intfc_prefix_common}/api/collection/activity/info?`,
    method: 'GET',
    params: {
      activityId: activityId
    }
  })
}

export function getUploadMerge (data) {
  return request({
    url: `${intfc_prefix_common}/api/collection/upload/file/merge`,
    method: 'post',
    data
  })
}
export function getUploadFragment (data, test) {
  console.log(data, test, 'data', 'test')
  return request({
    url: `${intfc_prefix_common}/api/collection/upload/file/fragmentation?index=${test.index}&uuid=${test.uuid}`,
    method: 'post',
    data
  })
}
